import React from 'react';
import { MdLock, MdInfo, MdGroup, MdArrowForward } from 'react-icons/md';

const TeamAccessRestriction = ({ 
  message = "To access team management features, please subscribe to our course.",
  onSubscribe,
  onGoBack
}) => {
  const handleSubscribe = () => {
    if (onSubscribe) {
      onSubscribe();
    } else {
      window.location.href = '/admin/courses';
    }
  };

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      window.location.href = '/admin/dashboard';
    }
  };

  return (
    <div className="absolute inset-0 bg-white/80 dark:bg-navy-800/80 backdrop-blur-sm z-10 rounded-[20px] flex items-center justify-center">
      <div className="text-center p-8 max-w-md">
        {/* Icon */}
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-100 to-pink-100 dark:from-orange-900 dark:to-pink-900 flex items-center justify-center mx-auto mb-4">
          <MdGroup className="text-3xl text-orange-500 dark:text-orange-400" />
        </div>
        
        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
          Team Management Locked
        </h3>
        
        {/* Message */}
        <div className="mb-6">
          <div className="flex items-center justify-center gap-2 mb-2">
            <MdInfo className="text-orange-500" size={18} />
            <span className="text-sm font-medium text-orange-600 dark:text-orange-400">
              Subscription Required
            </span>
          </div>
                  <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
          {message}
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-2 leading-relaxed">
          <strong>Note:</strong> Once you subscribe, you'll have permanent access to team features, even if your subscription expires later.
        </p>
        </div>
        
        {/* Info Box */}
        <div className="mb-6 p-3 bg-orange-50 dark:bg-orange-900/20 rounded-lg border border-orange-200 dark:border-orange-700">
          <p className="text-xs text-orange-700 dark:text-orange-300">
            <strong>Current Access:</strong> You can view all teams and calendar, but cannot create, edit, or manage your own teams.
          </p>
        </div>
        
        {/* Action Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleSubscribe}
            className="w-full px-6 py-3 rounded-lg bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 transition-all duration-200 text-white font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center justify-center gap-2"
          >
            Subscribe Now
            <MdArrowForward size={16} />
          </button>
          
          <button
            onClick={handleGoBack}
            className="w-full px-6 py-3 rounded-lg border-2 border-gray-300 dark:border-navy-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-navy-700 transition-all duration-200 font-medium"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamAccessRestriction; 